/* ==========================================================================
   TSH · Carrito — lógica
   The Sole Hunters · Tema Tinker (Horizon)
   --------------------------------------------------------------------------
   Custom element <tsh-cart>. Se auto-registra.
   Depende de: assets/tsh-cart.css
   Abre con:  [data-tsh-cart-open] · evento 'tsh:cart:open' · window.TshCart.open()
   Emite:     cart:update (lo recoge el contador del header)
   Emite:     tsh:cart:opened · tsh:cart:closed
   Incluye:   motor de venta cruzada del carrito (al final del archivo)
              medición para el panel de impacto (último bloque)
              eventos para el píxel "TSH Panel" (Shopify.analytics.publish)
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('tsh-cart')) return;

  /* Idioma de la tienda (atributo lang del <html>): en /en todo sale en inglés */
  var EN = /^en\b/i.test(document.documentElement.lang || '');

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function money(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var loc = EN ? 'en-IE' : 'es-ES';
      return new Intl.NumberFormat(loc, {
        style: 'currency', currency: cur
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : String(str);
    return d.innerHTML;
  }

  function imgUrl(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }

  /* Eventos para el píxel personalizado "TSH Panel" (Ajustes → Eventos de
     clientes). Sin datos personales. Si el píxel no existe, no pasa nada. */
  function tshPublish(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  function upsCardInfo(card, i) {
    var titleEl = card.querySelector('.tsh-up__title');
    var price = card.dataset.upsPrice ? Number(card.dataset.upsPrice) / 100 : null;
    return {
      productId: card.dataset.upsPid || '',
      title: card.dataset.upsTitle || (titleEl ? titleEl.textContent.trim() : ''),
      category: card.dataset.upsCat || '',
      price: price,
      position: i + 1
    };
  }

  var I = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>',
    minus: '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8"/></svg>',
    plus:  '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 2v8M2 6h8"/></svg>'
  };

  class TshCart extends HTMLElement {

    /* ======================================================================
       ARRANQUE
       ====================================================================== */
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      try {
        this.veil     = document.querySelector('[data-tsh-cart-veil]');
        this.linesEl  = this.querySelector('[data-cart-lines]');
        this.emptyEl  = this.querySelector('[data-cart-empty]');
        this.countEl  = this.querySelector('[data-cart-title-count]');
        this.totalEl  = this.querySelector('[data-cart-total]');
        this.shipEl   = this.querySelector('[data-ship]');

        this.threshold = parseInt(this.dataset.freeShipping, 10) || 0;
        this.pending = 0;
        this.dirty = false;

        // El Liquid ya pintó el carrito correcto: partimos de ahí, sin red
        this.count = parseInt(this.dataset.initialCount, 10) || 0;
        this.total = parseInt(this.dataset.initialTotal, 10) || 0;
        this.wasComplete = this.threshold > 0 && this.total >= this.threshold;
        this.classList.toggle('is-empty', this.count === 0);

        this.bindTriggers();
        this.bindPanel();
        this.bindDelegated();
        this.bindNote();
        this.bindUpsellVariants();
        this.interceptForms();

        window.TshCart = {
          open: this.open.bind(this),
          close: this.close.bind(this),
          refresh: this.fetchCart.bind(this),
          add: this.addItem.bind(this)
        };
      } catch (err) {
        console.error('[TSH cart] init', err);
      }
    }

    /* ======================================================================
       APERTURA Y CIERRE
       ====================================================================== */
    bindTriggers() {
      var self = this;

      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-tsh-cart-open]') : null;
        if (!t) return;
        e.preventDefault();
        self.open();
      });

      document.addEventListener('tsh:cart:open', function () { self.open(); });
    }

    bindPanel() {
      var self = this;

      var closeBtn = this.querySelector('[data-cart-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });

      if (this.veil) this.veil.addEventListener('click', function () { self.close(); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
      });

      // Cerrar arrastrando hacia la derecha en móvil
      var startX = null, startY = null, dragging = false;

      this.addEventListener('touchstart', function (e) {
        if (window.innerWidth > 749) return;
        // No secuestramos gestos sobre elementos con scroll horizontal
        if (e.target.closest('.tsh-ups__rail')) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragging = false;
      }, { passive: true });

      this.addEventListener('touchmove', function (e) {
        if (startX === null) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (!dragging && Math.abs(dx) > Math.abs(dy) + 10) dragging = true;
        if (dragging && dx > 0) {
          self.style.transition = 'none';
          self.style.transform = 'translateX(' + dx + 'px)';
        }
      }, { passive: true });

      this.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        self.style.removeProperty('transition');
        self.style.removeProperty('transform');
        if (dragging && dx > 100) self.close();
        startX = startY = null;
        dragging = false;
      });
    }

    open() {
      if (this.classList.contains('is-open')) return;

      this.hidden = false;
      if (this.veil) this.veil.hidden = false;

      // Dos frames: el primero aplica hidden=false, el segundo dispara la transición
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.add('is-open');
          if (this.veil) this.veil.classList.add('is-open');
        });
      });

      this.lock(true);
      this.trapFocus();
      document.dispatchEvent(new CustomEvent('tsh:cart:opened'));

      setTimeout(() => {
        var first = this.querySelector('[data-cart-close]');
        if (first) first.focus({ preventScroll: true });
      }, 260);

      // Solo consultamos al servidor si algo cambió fuera de este componente
      if (this.dirty) {
        this.dirty = false;
        this.fetchCart();
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;

      this.classList.remove('is-open');
      if (this.veil) this.veil.classList.remove('is-open');

      this.lock(false);
      this.releaseFocus();
      document.dispatchEvent(new CustomEvent('tsh:cart:closed'));

      setTimeout(() => {
        if (!this.classList.contains('is-open')) {
          this.hidden = true;
          if (this.veil) this.veil.hidden = true;
        }
      }, 620);
    }

    lock(on) {
      if (on) {
        var sb = window.innerWidth - document.documentElement.clientWidth;
        if (sb > 0) document.body.style.paddingRight = sb + 'px';
        document.body.classList.add('tsh-cart-locked');
      } else {
        document.body.classList.remove('tsh-cart-locked');
        document.body.style.removeProperty('padding-right');
      }
    }

    trapFocus() {
      var self = this;
      this.releaseFocus(true);
      this.lastFocused = document.activeElement;

      this.trapHandler = function (e) {
        if (e.key !== 'Tab') return;
        var nodes = Array.prototype.slice.call(self.querySelectorAll(FOCUSABLE))
          .filter(function (n) { return n.offsetParent !== null; });
        if (!nodes.length) return;

        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', this.trapHandler);
    }

    releaseFocus(silent) {
      if (this.trapHandler) {
        document.removeEventListener('keydown', this.trapHandler);
        this.trapHandler = null;
      }
      if (!silent && this.lastFocused && this.lastFocused.focus) {
        try { this.lastFocused.focus(); } catch (e) {}
      }
      this.lastFocused = null;
    }

    /* ======================================================================
       ACCIONES DELEGADAS
       ====================================================================== */
    bindDelegated() {
      var self = this;

      this.addEventListener('click', function (e) {
        var el;

        el = e.target.closest('[data-line-remove]');
        if (el) {
          e.preventDefault();
          self.changeLine(el.closest('[data-line]'), 0);
          return;
        }

        el = e.target.closest('[data-qty-step]');
        if (el) {
          e.preventDefault();
          var line = el.closest('[data-line]');
          var input = line.querySelector('[data-qty-input]');
          var next = (parseInt(input.value, 10) || 1) + parseInt(el.dataset.qtyStep, 10);
          self.changeLine(line, Math.max(0, next));
          return;
        }

        el = e.target.closest('[data-upsell-add]');
        if (el) {
          e.preventDefault();
          self.addUpsell(el);
          return;
        }

        el = e.target.closest('[data-cart-checkout]');
        if (el) {
          e.preventDefault();
          el.classList.add('is-loading');
          window.location.href = ROOT + 'checkout';
          return;
        }
      });

      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (!input) return;
        var line = input.closest('[data-line]');
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < 0) val = 1;
        self.changeLine(line, val);
      });
    }

    /* ======================================================================
       UPSELLS CON TALLA — el selector vive en el carrito
       ====================================================================== */
    bindUpsellVariants() {
      /* Delegado: sirve igual para las tarjetas que pinta el Liquid y para
         las que pinta después el motor de venta cruzada. */
      var sync = function (select) {
        var card = select.closest('.tsh-up');
        if (!card) return;
        var opt = select.options[select.selectedIndex];
        if (!opt) return;

        var btn = card.querySelector('[data-upsell-add]');
        var price = card.querySelector('[data-upsell-price]');
        var was = card.querySelector('[data-upsell-was]');
        var available = opt.dataset.available === 'true';

        if (btn) {
          btn.classList.remove('is-choose');
          btn.dataset.upsellAdd = opt.value;
          btn.disabled = !available;
          btn.textContent = available ? (btn.dataset.label || (EN ? 'Add' : 'Añadir')) : (EN ? 'Sold out' : 'Agotado');
        }
        if (price && opt.dataset.price) price.textContent = opt.dataset.price;
        if (was) {
          was.textContent = opt.dataset.was || '';
          was.hidden = !opt.dataset.was;
        }
      };

      this.addEventListener('change', function (e) {
        var select = e.target.closest && e.target.closest('[data-upsell-variants]');
        if (select) sync(select);
      });

      this.querySelectorAll('[data-upsell-variants]').forEach(sync);
    }

    /* ======================================================================
       NOTA DEL PEDIDO
       ====================================================================== */
    bindNote() {
      var self = this;
      var wrap = this.querySelector('[data-note]');
      if (!wrap) return;

      var toggle = wrap.querySelector('[data-note-toggle]');
      var field  = wrap.querySelector('[data-note-field]');
      if (!toggle || !field) return;

      toggle.addEventListener('click', function () {
        var open = !wrap.classList.contains('is-open');
        wrap.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        if (open) setTimeout(function () { field.focus(); }, 340);
      });

      var timer = null;
      field.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: field.value })
          }).catch(function (err) { console.error('[TSH cart] note', err); });
        }, 700);
      });
    }

    /* ======================================================================
       INTERCEPCIÓN DE FORMULARIOS
       ====================================================================== */
    interceptForms() {
      var self = this;

      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        if (self.contains(form)) return;

        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;

        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');

        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'add'); });
            return res.json();
          })
          .then(function () {
            // Abrimos ya y refrescamos en paralelo: se percibe instantáneo
            self.open();
            return self.fetchCart();
          })
          .catch(function (err) {
            console.error('[TSH cart] add', err);
            alert(err.message || (EN ? 'Couldn’t add the product.' : 'No se pudo añadir el producto.'));
          })
          .finally(function () {
            if (btn) btn.classList.remove('is-loading');
          });
      }, true);

      // Cambios desde fuera: marcamos sucio y refrescamos al abrir
      ['cart:added', 'tsh:cart:dirty'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          if (self.classList.contains('is-open')) self.fetchCart();
          else self.dirty = true;
        });
      });

      // Volver con el botón atrás devuelve HTML cacheado
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) self.dirty = true;
      });
    }

    /* ======================================================================
       API DEL CARRITO
       ====================================================================== */
    busy(on) {
      this.pending += on ? 1 : -1;
      this.classList.toggle('is-syncing', this.pending > 0);
    }

    fetchCart() {
      var self = this;
      this.busy(true);

      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.apply(cart);
          return cart;
        })
        .catch(function (err) { console.error('[TSH cart] fetch', err); })
        .finally(function () { self.busy(false); });
    }

    changeLine(lineEl, quantity) {
      if (!lineEl) return;
      var self = this;
      var key = lineEl.dataset.line;

      // Respuesta óptica inmediata
      lineEl.classList.add(quantity === 0 ? 'is-removing' : 'is-busy');
      this.busy(true);

      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            // Esperamos a que termine la animación de salida
            setTimeout(function () { self.apply(cart); }, 260);
          } else {
            self.apply(cart);
          }
        })
        .catch(function (err) {
          console.error('[TSH cart] change', err);
          lineEl.classList.remove('is-removing', 'is-busy');
        })
        .finally(function () { self.busy(false); });
    }

    addItem(variantId, quantity, properties) {
      var self = this;
      this.busy(true);

      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (properties) item.properties = properties;

      return fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'add'); });
          return res.json();
        })
        .then(function () { return self.fetchCart(); })
        .finally(function () { self.busy(false); });
    }

    addUpsell(btn) {
      var self = this;
      if (!btn.dataset.upsellAdd || btn.disabled) return;
      var original = btn.dataset.label || btn.textContent;

      btn.classList.add('is-loading');
      btn.textContent = '···';

      var card = btn.closest('.tsh-up');
      var cards = card && card.parentNode ? Array.prototype.slice.call(card.parentNode.querySelectorAll('.tsh-up')) : [];
      var info = card ? upsCardInfo(card, Math.max(0, cards.indexOf(card))) : { productId: '', title: '', category: '', price: null, position: 0 };
      info.variantId = String(btn.dataset.upsellAdd);

      /* Propiedad oculta (empieza por _): no sale en el checkout, pero sí en
         el pedido del admin. Así se puede medir qué se vende desde aquí. */
      this.addItem(btn.dataset.upsellAdd, 1, { _origen: 'Recomendado en carrito' })
        .then(function () {
          tshPublish('tsh_upsell_add', info);
          /* Respaldo para el píxel: qué productos se añadieron desde el
             carril en esta visita (por si el checkout no deja ver _origen) */
          if (info.productId) {
            try {
              var added = JSON.parse(sessionStorage.getItem('tsh:ups-added') || '[]');
              if (added.indexOf(info.productId) === -1) added.push(info.productId);
              sessionStorage.setItem('tsh:ups-added', JSON.stringify(added.slice(-30)));
            } catch (e) {}
          }
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          btn.textContent = (EN ? 'Added' : 'Añadido');
          setTimeout(function () {
            btn.classList.remove('is-done');
            btn.textContent = original;
          }, 1600);
        })
        .catch(function (err) {
          console.error('[TSH cart] upsell', err);
          btn.classList.remove('is-loading');
          btn.textContent = (EN ? 'Sold out' : 'Agotado');
          setTimeout(function () { btn.textContent = original; }, 1600);
        });
    }

    /* ======================================================================
       RENDER
       ====================================================================== */
    apply(cart) {
      if (!cart) return;

      this.count = cart.item_count;
      this.total = cart.total_price;

      var empty = cart.item_count === 0;
      this.classList.toggle('is-empty', empty);

      if (this.countEl) this.countEl.textContent = empty ? '' : '(' + cart.item_count + ')';
      if (this.emptyEl) this.emptyEl.hidden = !empty;
      if (this.linesEl) {
        this.linesEl.hidden = empty;
        if (!empty) this.renderLines(cart.items);
        else this.linesEl.innerHTML = '';
      }
      if (this.totalEl) this.totalEl.textContent = money(cart.total_price);

      this.renderShipping(cart.total_price);

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { item_count: cart.item_count, cart: cart }
      }));
    }

    renderLines(items) {
      var html = '';

      items.forEach(function (item) {
        var img = item.image ? imgUrl(item.image, 220) : '';

        var opts = (item.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return esc(o.value); })
          .join(' · ');

        var hasDiscount = item.original_line_price > item.final_line_price;

        var disc = '';
        if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
          disc = item.line_level_discount_allocations.map(function (d) {
            return '<span class="tsh-line__discount">' + esc(d.discount_application.title) + '</span>';
          }).join('');
        }

        html +=
          '<li class="tsh-line" data-line="' + esc(item.key) + '">' +
            '<a class="tsh-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + esc(img) + '" alt="" width="110" height="147" loading="lazy" decoding="async">' : '') +
            '</a>' +
            '<div class="tsh-line__body">' +
              '<div class="tsh-line__top">' +
                '<a class="tsh-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
                '<button type="button" class="tsh-line__remove" data-line-remove aria-label="' + (EN ? 'Remove' : 'Quitar') + ' ' + esc(item.product_title) + '">' + I.trash + '</button>' +
              '</div>' +
              (opts ? '<p class="tsh-line__variant">' + opts + '</p>' : '') +
              disc +
              '<div class="tsh-line__foot">' +
                '<div class="tsh-qty">' +
                  '<button type="button" class="tsh-qty__btn" data-qty-step="-1" aria-label="' + (EN ? 'Decrease quantity' : 'Restar uno') + '">' + I.minus + '</button>' +
                  '<input class="tsh-qty__input" type="number" inputmode="numeric" min="0" value="' + item.quantity + '" data-qty-input aria-label="' + (EN ? 'Quantity' : 'Cantidad') + '">' +
                  '<button type="button" class="tsh-qty__btn" data-qty-step="1" aria-label="' + (EN ? 'Increase quantity' : 'Sumar uno') + '">' + I.plus + '</button>' +
                '</div>' +
                '<div class="tsh-line__prices">' +
                  (hasDiscount ? '<span class="tsh-line__price-was">' + money(item.original_line_price) + '</span>' : '') +
                  '<span class="tsh-line__price">' + money(item.final_line_price) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</li>';
      });

      this.linesEl.innerHTML = html;
    }

    renderShipping(total) {
      if (!this.shipEl || !this.threshold) return;

      var labelEl = this.shipEl.querySelector('[data-ship-text]');
      var fillEl  = this.shipEl.querySelector('[data-ship-fill]');
      if (!labelEl || !fillEl) return;

      var complete = total >= this.threshold;
      var pct = Math.min(100, (total / this.threshold) * 100);
      var left = Math.max(0, this.threshold - total);

      fillEl.style.width = (total === 0 ? 0 : Math.max(4, pct)) + '%';
      this.shipEl.classList.toggle('is-complete', complete);

      if (complete) {
        labelEl.innerHTML = '<strong>' + esc(this.dataset.shipDone || (EN ? 'You’ve unlocked free shipping!' : '¡Envío gratis conseguido!')) + '</strong>';
      } else {
        var tpl = this.dataset.shipLeft || (EN ? 'You’re {amount} away from free shipping' : 'Te faltan {amount} para el envío gratis');
        labelEl.innerHTML = esc(tpl).replace('{amount}', '<strong>' + money(left) + '</strong>');
      }

      if (complete && !this.wasComplete) {
        this.shipEl.classList.add('just-completed');
        setTimeout(() => this.shipEl.classList.remove('just-completed'), 700);
      }
      this.wasComplete = complete;
    }
  }

  customElements.define('tsh-cart', TshCart);

  /* ======================================================================
     MOTOR DE VENTA CRUZADA
     ----------------------------------------------------------------------
     Decide qué extras enseñar mirando el carrito entero, no solo el último
     producto. Para cada candidato calcula una puntuación con estas señales:

       1 · Complemento   Qué categoría casa con lo que ya llevan.
                         Zapatillas → gorra y camiseta. Camiseta → gorra y
                         pantalón. Sudadera → pantalón. Gorra → 3x2.
       2 · Precio        El extra tiene que sentirse pequeño al lado de la
                         compra principal: idealmente entre el 12% y el 45%
                         de su precio. Nada que compita con ella.
       3 · Envío gratis  Si falta poco, sube lo que cierra el hueco justo,
                         sin pasarse mucho.
       4 · 3x2 gorras    Con 2 gorras dentro, la tercera es gratis: va
                         primera. Con 1, se recuerda la promo.
       5 · Marca         Misma marca que lo que llevan, o marca española si
                         compran marca española.
       6 · Talla         Si llevan ropa en M, la ropa sugerida sale ya en M.
                         Si no hay su talla, baja en la lista.
       7 · Descuento     Lo rebajado tiene un pequeño empujón.
       8 · Curado        Lo que marques como complementario en la app
                         Search & Discovery de Shopify pasa por delante.

     De dónde salen los candidatos: de las colecciones de abajo (POOLS),
     cargadas una vez por sesión y guardadas 20 minutos. Nunca repite algo
     que ya está en el carrito y nunca enseña más de 2 por categoría, para
     que el carril no sea un muro de gorras.

     Si el carrito se vacía o algo falla, vuelve la colección fija que
     pinta el Liquid. Nada se rompe.

     Consola:  TshUpsells.explain()  → tabla con la puntuación de cada
               candidato y el motivo. Para revisar por qué sale lo que sale.
     ====================================================================== */
  (function crossSell() {
    var box = document.querySelector('[data-cart-upsell]');
    if (!box || box.dataset.smart !== 'true') return;

    var rail = box.querySelector('[data-ups-rail]');
    if (!rail) return;

    var titleEl = box.querySelector('.tsh-ups__title');
    var cartEl = document.querySelector('tsh-cart');

    /* --------------------------------------------------------------------
       CONFIGURACIÓN
       -------------------------------------------------------------------- */
    var CFG = {
      limit: parseInt(box.dataset.limit, 10) || 8,

      /* Colección de la que sale cada categoría y cuántos productos se
         leen de cada una. Accesorios va corto a propósito: más abajo en esa
         colección están las Mystery Box, que pesan 1 MB cada una. */
      pools: {
        cap:    { handle: 'gorras',     size: 48 },
        tee:    { handle: 'camisetas',  size: 48 },
        hoodie: { handle: 'sudaderas',  size: 40 },
        pants:  { handle: 'pantalones', size: 40 },
        acc:    { handle: 'accesorios', size: 12 }
      },

      cacheMinutes: 20,

      /* 3x2 en gorras. Ponlo en false el día que acabe la promo. */
      capsDeal: true,

      maxPerCat: 2,

      /* Nunca se recomiendan */
      exclude: /mystery\s*box|gift\s*card|tarjeta\s*regalo/i,

      spanishBrands: ['6ixt4our', 'maison host', 'leal collective', 'ürco', 'urco',
                      'classified', 'excesu', 'delaccua', 'noemotions']
    };

    /* Qué casa con qué. 1 = complemento perfecto, 0 = no se sugiere. */
    var COMP = {
      sneakers: { cap: .90, tee: .85, hoodie: .55, pants: .45, acc: .50 },
      tee:      { cap: .90, pants: .70, hoodie: .60, tee: .35, acc: .40 },
      hoodie:   { pants: .80, cap: .75, tee: .60, acc: .35, hoodie: .20 },
      pants:    { tee: .85, hoodie: .70, cap: .65, acc: .30, pants: .20 },
      cap:      { tee: .75, acc: .55, cap: .50, hoodie: .45, pants: .35 },
      acc:      { cap: .60, tee: .60, acc: .45, hoodie: .35 },
      other:    { cap: .60, tee: .60, acc: .50, hoodie: .35 }
    };

    var ORDER = ['cap', 'tee', 'hoodie', 'pants', 'acc'];
    var APPAREL_SIZE = /^(xxs|xs|s|m|l|xl|xxl|2xl|xxxl|3xl)$/i;

    var THRESHOLD = cartEl ? (parseInt(cartEl.dataset.freeShipping, 10) || 0) : 0;

    var fallbackHtml = rail.innerHTML;
    var fallbackTitle = titleEl ? titleEl.textContent : '';

    var pools = {};
    var inflight = {};
    var recoCache = {};
    var seq = 0;
    var lastSig = '';
    var lastCart = null;
    var lastPlan = null;
    var holdUntil = 0;
    var holdTimer = null;

    injectStyles();

    /* --------------------------------------------------------------------
       CLASIFICACIÓN
       -------------------------------------------------------------------- */
    function classifyText(type, text) {
      type = String(type || '').toLowerCase();
      text = String(text || '').toLowerCase();

      if (/zapatilla|sneaker/.test(type)) return 'sneakers';
      if (/pok[eé]mon|coleccionable|carta/.test(type)) return 'other';

      if (/\bgorr[ao]s?\b|\bcaps?\b|59fifty|9forty|9fifty|9twenty|snapback|trucker|beanie|bucket hat/.test(text)) return 'cap';
      if (/pant|jogger|cargo|\bshorts?\b|bermuda|\bjorts?\b|\bjeans?\b|trouser|ch[aá]ndal/.test(text)) return 'pants';
      if (/hoodie|sudadera|crewneck|sweatshirt|\bzip\b|jacket|chaqueta|cortavientos|anorak|fleece|polar/.test(text)) return 'hoodie';
      if (/\btee\b|t-shirt|camiseta|\bshirt\b|\bpolo\b|jersey|\btank\b/.test(text)) return 'tee';

      if (/accesorio/.test(type)) return 'acc';
      if (/streetwear/.test(type)) return 'tee';
      return 'other';
    }

    /* Primero manda la colección (es la verdad); si no aparece en ninguna,
       se deduce por tipo y título. */
    function catOfLine(item) {
      for (var i = 0; i < ORDER.length; i++) {
        var list = pools[ORDER[i]];
        if (!list) continue;
        for (var j = 0; j < list.length; j++) {
          if (list[j].id === item.product_id) return ORDER[i];
        }
      }
      return classifyText(item.product_type, (item.product_title || '') + ' ' + (item.handle || ''));
    }

    function lineSize(item) {
      var opts = item.options_with_values || [];
      for (var i = 0; i < opts.length; i++) {
        var v = String(opts[i].value || '').trim();
        if (/talla|size/i.test(opts[i].name || '') && APPAREL_SIZE.test(v)) return v.toUpperCase();
      }
      return null;
    }

    /* --------------------------------------------------------------------
       NORMALIZACIÓN
       La API de colecciones da precios en euros como texto; la de
       recomendaciones, en céntimos. Aquí todo queda en céntimos.
       -------------------------------------------------------------------- */
    function eurosToCents(v) {
      if (v == null || v === '') return 0;
      return Math.round(parseFloat(v) * 100) || 0;
    }

    function optionNames(p) {
      return (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    }

    function finish(base, rawVariants, toCents) {
      var variants = (rawVariants || []).map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: !!v.available,
          price: toCents(v.price),
          was: toCents(v.compare_at_price),
          opts: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; })
        };
      });
      if (!variants.some(function (v) { return v.available; })) return null;
      if (CFG.exclude.test(base.title)) return null;

      base.variants = variants;
      base.sized = base.opts.some(function (n) { return /talla|size/i.test(n); }) &&
                   variants.some(function (v) { return v.opts.some(function (o) { return APPAREL_SIZE.test(String(o).trim()); }); });
      return base;
    }

    function normPool(p, cat, idx, total) {
      return finish({
        id: p.id,
        title: p.title,
        vendor: p.vendor || '',
        url: ROOT + 'products/' + p.handle,
        img: p.images && p.images[0] ? p.images[0].src : '',
        cat: cat,
        opts: optionNames(p),
        rank: total > 1 ? 1 - idx / (total - 1) : 1
      }, p.variants, eurosToCents);
    }

    function normReco(p) {
      return finish({
        id: p.id,
        title: p.title,
        vendor: p.vendor || '',
        url: p.url || (ROOT + 'products/' + p.handle),
        img: p.featured_image || (p.images && p.images[0]) || '',
        cat: classifyText(p.type || p.product_type, p.title + ' ' + (p.handle || '')),
        opts: optionNames(p),
        rank: .5
      }, p.variants, function (v) { return v == null ? 0 : Number(v) || 0; });
    }

    /* --------------------------------------------------------------------
       CARGA DE CANDIDATOS
       -------------------------------------------------------------------- */
    function loadPool(cat) {
      if (pools[cat]) return Promise.resolve(pools[cat]);
      if (inflight[cat]) return inflight[cat];

      var conf = CFG.pools[cat];
      var key = 'tsh-ups:v2:' + conf.handle + ':' + conf.size;

      try {
        var raw = sessionStorage.getItem(key);
        if (raw) {
          var cached = JSON.parse(raw);
          if (cached && Date.now() - cached.t < CFG.cacheMinutes * 60000) {
            pools[cat] = cached.items;
            return Promise.resolve(cached.items);
          }
        }
      } catch (e) {}

      inflight[cat] = fetch(ROOT + 'collections/' + conf.handle + '/products.json?limit=' + conf.size)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var list = (data && data.products) || [];
          var items = list.map(function (p, i) { return normPool(p, cat, i, list.length); }).filter(Boolean);
          pools[cat] = items;
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
          return items;
        })
        .catch(function (err) {
          console.warn('[TSH ups] colección ' + conf.handle, err);
          pools[cat] = [];
          return [];
        })
        .then(function (items) {
          delete inflight[cat];
          return items;
        });

      return inflight[cat];
    }

    /* Lo que el equipo haya marcado como complementario en Search & Discovery */
    function loadReco(productId) {
      if (!productId) return Promise.resolve([]);
      if (recoCache[productId]) return Promise.resolve(recoCache[productId]);

      return fetch(ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) +
                   '&limit=10&intent=complementary')
        .then(function (res) { return res.ok ? res.json() : { products: [] }; })
        .then(function (data) {
          var items = ((data && data.products) || []).map(normReco).filter(Boolean);
          recoCache[productId] = items;
          return items;
        })
        .catch(function () {
          recoCache[productId] = [];
          return [];
        });
    }

    /* --------------------------------------------------------------------
       LECTURA DEL CARRITO
       -------------------------------------------------------------------- */
    function analyse(cart) {
      var items = (cart && cart.items) || [];

      var lines = items.map(function (it) {
        return {
          id: it.product_id,
          cat: catOfLine(it),
          price: it.final_price || it.price || 0,
          qty: it.quantity || 1,
          vendor: String(it.vendor || '').toLowerCase(),
          size: lineSize(it)
        };
      });

      var anchor = lines.slice().sort(function (a, b) { return b.price - a.price; })[0];

      var inCart = {}, vendors = {}, cats = {}, sizes = {};
      var capsQty = 0;

      lines.forEach(function (l) {
        inCart[l.id] = true;
        if (l.vendor && l.vendor !== 'vendor-unknown') vendors[l.vendor] = true;
        cats[l.cat] = (cats[l.cat] || 0) + l.qty;
        if (l.size) sizes[l.size] = (sizes[l.size] || 0) + l.qty;
        if (l.cat === 'cap') capsQty += l.qty;
      });

      var size = Object.keys(sizes).sort(function (a, b) { return sizes[b] - sizes[a]; })[0] || null;

      /* El peso de cada categoría sale de la compra principal; el resto de
         líneas suman, pero menos. */
      var weights = {};
      lines.forEach(function (l) {
        var m = l === anchor ? 1 : .7;
        var comp = COMP[l.cat] || COMP.other;
        Object.keys(comp).forEach(function (c) {
          weights[c] = Math.max(weights[c] || 0, comp[c] * m);
        });
      });

      var spanish = Object.keys(vendors).some(isSpanish);

      return {
        anchor: anchor,
        inCart: inCart,
        vendors: vendors,
        cats: cats,
        size: size,
        capsQty: capsQty,
        weights: weights,
        spanish: spanish,
        gap: THRESHOLD > 0 ? Math.max(0, THRESHOLD - (cart.total_price || 0)) : 0
      };
    }

    function isSpanish(vendor) {
      vendor = String(vendor || '').toLowerCase();
      return CFG.spanishBrands.indexOf(vendor) > -1;
    }

    /* --------------------------------------------------------------------
       PUNTUACIÓN
       -------------------------------------------------------------------- */
    function pickVariant(p, size) {
      var available = p.variants.filter(function (v) { return v.available; });
      if (!available.length) return null;

      if (size && p.sized) {
        for (var i = 0; i < available.length; i++) {
          var hit = available[i].opts.some(function (o) { return String(o).trim().toUpperCase() === size; });
          if (hit) return { v: available[i], sizeMatch: true };
        }
        return { v: available[0], sizeMatch: false };
      }
      return { v: available[0], sizeMatch: null };
    }

    function score(p, a, recoIds) {
      var w = a.weights[p.cat] || 0;
      if (w <= 0 || a.inCart[p.id]) return null;

      var pick = pickVariant(p, a.size);
      if (!pick) return null;
      var v = pick.v;
      var price = v.price;
      if (!price) return null;

      var A = Math.max(a.anchor ? a.anchor.price : 0, 1);

      /* Techo de precio: un extra no puede competir con la compra. */
      var ceil = Math.max(A * .75, 4500);
      if (a.gap > 0) ceil = Math.max(ceil, a.gap + 2500);
      var over = price > ceil;

      /* Encaje de precio respecto a la compra principal */
      var r = price / A, fit;
      if (r < .12)       fit = .70;
      else if (r <= .45) fit = 1;
      else if (r <= .75) fit = 1 - (r - .45) / .30 * .5;
      else               fit = .35;

      var s = w + fit * .6 + (p.rank || 0) * .12;
      var why = [];
      var chip = null;
      var brandChip = null;

      /* 3x2 en gorras */
      var deal = (CFG.capsDeal && p.cat === 'cap') ? a.capsQty % 3 : -1;
      if (deal === 2) { s += 1.1; chip = { k: 'deal', t: (EN ? '3 for 2 · One free' : '3x2 · Una gratis') }; why.push('3x2: tercera gratis'); }
      else if (deal === 1) { s += .45; chip = { k: 'deal', t: (EN ? '3 for 2 on caps' : '3x2 en gorras') }; why.push('3x2: lleva 1'); }
      else if (deal === 0 && CFG.capsDeal) { s += .08; }

      /* Repetir categoría resta, salvo que sea para completar el 3x2 */
      var have = a.cats[p.cat] || 0;
      if (have && !(deal === 1 || deal === 2)) {
        s -= .25 * Math.min(have, 2);
        why.push('ya lleva ' + p.cat);
      }

      /* Envío gratis */
      if (a.gap > 0) {
        if (price >= a.gap) {
          var overshoot = (price - a.gap) / (a.gap + 2000);
          var bonus = .75 * Math.max(0, 1 - overshoot);
          s += bonus;
          if (bonus > .45 && !chip) chip = { k: 'ship', t: (EN ? 'Unlocks free shipping' : 'Con esto, envío gratis') };
          why.push('cierra envío +' + bonus.toFixed(2));
        } else {
          s += .2 * price / a.gap;
        }
      }

      /* Marca */
      var brand = String(p.vendor || '').toLowerCase();
      if (brand && brand !== 'vendor-unknown' && a.vendors[brand]) {
        s += .25;
        brandChip = { k: 'brand', t: (EN ? 'More from ' : 'Más de ') + p.vendor };
        if (!chip) chip = brandChip;
        why.push('misma marca');
      } else if (a.spanish && isSpanish(brand)) {
        s += .1;
        why.push('marca española');
      }

      /* Descuento */
      var off = v.was > price ? Math.round((1 - price / v.was) * 100) : 0;
      if (off >= 5) s += .12;

      /* Curado a mano en Search & Discovery */
      if (recoIds[p.id]) { s += .5; why.push('curado'); }

      /* Talla */
      if (pick.sizeMatch === false) { s -= .3; why.push('sin talla ' + a.size); }

      if (over) { s -= .8; why.push('caro para extra'); }

      return {
        p: p, v: v, s: s, chip: chip, alt: brandChip, off: off, over: over,
        sizeMatch: pick.sizeMatch, why: why
      };
    }

    function plan(cart, recoItems) {
      var a = analyse(cart);
      if (!a.anchor) return { a: a, out: [], all: [] };

      var recoIds = {};
      var byId = {};
      var cands = [];

      ORDER.forEach(function (c) {
        (pools[c] || []).forEach(function (p) {
          if (byId[p.id]) return;
          byId[p.id] = p;
          cands.push(p);
        });
      });

      (recoItems || []).forEach(function (p) {
        recoIds[p.id] = true;
        if (!byId[p.id] && p.cat !== 'sneakers') {
          byId[p.id] = p;
          cands.push(p);
        }
      });

      var all = cands.map(function (p) { return score(p, a, recoIds); })
                     .filter(Boolean)
                     .sort(function (x, y) { return y.s - x.s; });

      /* Selección: lo mejor primero, con tope por categoría y sin dos
         versiones del mismo modelo (tres 59FIFTY seguidas no venden más,
         ocupan sitio). Con la tercera gorra gratis en juego, las gorras
         pueden ocupar una plaza más. */
      var out = [], perCat = {}, families = {};
      var capMax = (CFG.capsDeal && a.capsQty % 3 === 2) ? 3 : CFG.maxPerCat;

      all.forEach(function (x) {
        if (out.length >= CFG.limit || x.over) return;
        var max = x.p.cat === 'cap' ? capMax : CFG.maxPerCat;
        if ((perCat[x.p.cat] || 0) >= max) return;
        var fam = family(x.p.title);
        if (families[fam]) return;
        families[fam] = true;
        perCat[x.p.cat] = (perCat[x.p.cat] || 0) + 1;
        out.push(x);
      });

      /* Si con los filtros quedan muy pocos, se completa con lo siguiente */
      if (out.length < Math.min(4, CFG.limit)) {
        all.forEach(function (x) {
          if (out.length >= CFG.limit || out.indexOf(x) > -1) return;
          out.push(x);
        });
      }

      /* Las dos primeras tarjetas, de categorías distintas: es lo que se
         ve sin deslizar. */
      if (out.length > 2 && out[0].p.cat === out[1].p.cat &&
          !(CFG.capsDeal && a.capsQty % 3 === 2 && out[0].p.cat === 'cap')) {
        for (var i = 2; i < out.length; i++) {
          if (out[i].p.cat !== out[0].p.cat) {
            var tmp = out[1]; out[1] = out[i]; out[i] = tmp;
            break;
          }
        }
      }

      /* Una etiqueta repetida en todas las tarjetas deja de decir nada:
         "envío gratis" solo en las dos primeras que lo consiguen. */
      var ships = 0;
      out.forEach(function (x) {
        if (x.chip && x.chip.k === 'ship') {
          ships++;
          if (ships > 2) x.chip = x.alt;
        }
      });

      return { a: a, out: out, all: all };
    }

    function family(title) {
      return String(title || '').toLowerCase()
        .replace(/[^a-z0-9áéíóúüñ ]+/g, ' ')
        .trim().split(/\s+/).slice(0, 3).join(' ');
    }

    /* --------------------------------------------------------------------
       PINTADO
       -------------------------------------------------------------------- */
    function headline(a, out) {
      if (CFG.capsDeal && a.capsQty % 3 === 2 && out.some(function (x) { return x.p.cat === 'cap'; })) {
        return (EN ? 'Add another cap: one is on us' : 'Añade otra gorra: una te sale gratis');
      }
      if (a.gap > 0 && out.some(function (x) { return x.chip && x.chip.k === 'ship'; })) {
        return (EN ? 'Reach free shipping' : 'Llega al envío gratis');
      }
      if (a.anchor && a.anchor.cat === 'sneakers') return (EN ? 'Pairs with your sneakers' : 'Combina con tus zapatillas');
      return (EN ? 'Complete the look' : 'Completa el look');
    }

    function cardHtml(x) {
      var p = x.p, v = x.v;

      var img = p.img
        ? '<img src="' + esc(imgUrl(p.img, 320)) + '" alt="" width="160" height="160" loading="lazy" decoding="async">'
        : '';

      var chip = x.chip
        ? '<span class="tsh-up__chip tsh-up__chip--' + x.chip.k + '">' + esc(x.chip.t) + '</span>'
        : '';

      /* Talla: si sabemos la suya (lleva ropa en M), sale ya elegida. Si
         no, se le pide: preseleccionar una talla cualquiera de una gorra
         ajustada o de una sudadera es comprar una devolución. */
      var select = '';
      var choose = p.variants.length > 1 && x.sizeMatch !== true;

      if (p.variants.length > 1) {
        select = '<select class="tsh-up__select" data-upsell-variants aria-label="' + (EN ? 'Size for ' : 'Talla de ') + esc(p.title) + '">' +
          (choose ? '<option value="" selected disabled>' + (EN ? 'Choose size' : 'Elige talla') + '</option>' : '') +
          p.variants.map(function (o) {
            return '<option value="' + o.id + '"' +
              ' data-available="' + o.available + '"' +
              ' data-price="' + esc(money(o.price)) + '"' +
              ' data-was="' + (o.was > o.price ? esc(money(o.was)) : '') + '"' +
              (o.available ? '' : ' disabled') +
              (!choose && o.id === v.id ? ' selected' : '') + '>' +
              esc(o.title) + (o.available ? '' : (EN ? ' — sold out' : ' — agotado')) +
            '</option>';
          }).join('') +
        '</select>';
      }

      var hasWas = v.was > v.price;

      return '<div class="tsh-up" data-ups-cat="' + p.cat + '" data-ups-pid="' + esc(p.id) + '"' +
        ' data-ups-title="' + esc(p.title) + '" data-ups-price="' + v.price + '">' +
        '<a class="tsh-up__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + chip + '</a>' +
        '<a class="tsh-up__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="tsh-up__price' + (hasWas ? ' has-was' : '') + '">' +
          '<span data-upsell-price>' + money(v.price) + '</span>' +
          '<s data-upsell-was' + (hasWas ? '' : ' hidden') + '>' + (hasWas ? money(v.was) : '') + '</s>' +
        '</p>' +
        select +
        (choose
          ? '<button type="button" class="tsh-up__add is-choose" data-upsell-add="" data-label="' + (EN ? 'Add' : 'Añadir') + '" disabled>' + (EN ? 'Choose size' : 'Elige talla') + '</button>'
          : '<button type="button" class="tsh-up__add" data-upsell-add="' + v.id + '" data-label="' + (EN ? 'Add' : 'Añadir') + '">' + (EN ? 'Add' : 'Añadir') + '</button>') +
      '</div>';
    }

    function render(result) {
      var out = result.out;
      if (!out.length) return;

      var title = headline(result.a, out);
      var sig = title + '|' + out.map(function (x) {
        return x.p.id + ':' + x.v.id + ':' + (x.chip ? x.chip.k : '');
      }).join(',');

      if (sig === lastSig) return;
      lastSig = sig;

      var left = rail.scrollLeft;
      rail.innerHTML = out.map(cardHtml).join('');
      rail.scrollLeft = Math.min(left, rail.scrollWidth);
      if (titleEl) titleEl.textContent = title;
      emitView();
    }

    /* Impresión del carril: una por cada vez que se abre el carrito o
       cambia lo que enseña con el carrito abierto. */
    var lastViewSig = '';
    function emitView() {
      if (!cartEl || !cartEl.classList.contains('is-open')) return;
      var cards = Array.prototype.slice.call(rail.querySelectorAll('.tsh-up'));
      if (!cards.length) return;
      var products = cards.map(upsCardInfo);
      var sig = products.map(function (x) { return x.productId || x.title; }).join(',');
      if (sig === lastViewSig) return;
      lastViewSig = sig;
      tshPublish('tsh_upsell_view', { headline: titleEl ? titleEl.textContent : '', products: products });
    }

    document.addEventListener('tsh:cart:opened', function () {
      lastViewSig = '';
      setTimeout(emitView, 400);
    });

    function restore() {
      if (!lastSig) return;
      lastSig = '';
      rail.innerHTML = fallbackHtml;
      if (titleEl) titleEl.textContent = fallbackTitle;
    }

    /* --------------------------------------------------------------------
       CICLO
       -------------------------------------------------------------------- */
    function refresh(cart) {
      lastCart = cart;
      var items = (cart && cart.items) || [];

      if (!items.length) { restore(); return; }

      /* Recién añadido desde aquí: dejamos ver el "Añadido" antes de
         recolocar el carril. */
      var wait = holdUntil - Date.now();
      if (wait > 0) {
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () { refresh(lastCart); }, wait);
        return;
      }

      var my = ++seq;
      var anchorItem = items.slice().sort(function (a, b) {
        return (b.final_price || 0) - (a.final_price || 0);
      })[0];

      Promise.all([
        Promise.all(ORDER.map(loadPool)),
        loadReco(anchorItem && anchorItem.product_id)
      ]).then(function (res) {
        if (my !== seq) return;
        var result = plan(cart, res[1]);
        lastPlan = result;
        render(result);
      }).catch(function (err) {
        console.warn('[TSH ups]', err);
      });
    }

    rail.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-upsell-add]')) holdUntil = Date.now() + 1400;
    }, true);

    /* paint() emite este evento con el carrito completo en el detalle */
    document.addEventListener('cart:update', function (e) {
      var d = e.detail || {};
      if (d.cart) refresh(d.cart);
    });

    /* Primera carga: sin prisa, cuando el navegador esté libre */
    var boot = function () {
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(refresh)
        .catch(function () {});
    };
    if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 2500 });
    else setTimeout(boot, 1200);

    /* --------------------------------------------------------------------
       DEPURACIÓN
       -------------------------------------------------------------------- */
    window.TshUpsells = {
      refresh: function () { lastSig = ''; if (lastCart) refresh(lastCart); },
      explain: function () {
        if (!lastPlan) { console.log('[TSH ups] aún no hay cálculo'); return; }
        var a = lastPlan.a;
        console.log('[TSH ups] principal:', a.anchor, '· talla:', a.size,
                    '· gorras:', a.capsQty, '· falta envío:', money(a.gap));
        console.table(lastPlan.all.slice(0, 25).map(function (x) {
          return {
            elegido: lastPlan.out.indexOf(x) > -1 ? '●' : '',
            puntos: x.s.toFixed(2),
            cat: x.p.cat,
            producto: x.p.title,
            precio: money(x.v.price),
            etiqueta: x.chip ? x.chip.t : '',
            motivos: x.why.join(' · ')
          };
        }));
      }
    };

    /* --------------------------------------------------------------------
       ESTILOS PROPIOS DEL MOTOR
       Van aquí para no tocar tsh-cart.css.
       -------------------------------------------------------------------- */
    function injectStyles() {
      if (document.getElementById('tsh-ups-css')) return;
      var css =
        '.tsh-up__media{position:relative}' +
        '.tsh-up__chip{position:absolute;left:6px;top:6px;z-index:1;max-width:calc(100% - 12px);' +
          'padding:3px 7px;font-size:10px;line-height:1.25;letter-spacing:-.01em;white-space:nowrap;' +
          'overflow:hidden;text-overflow:ellipsis;border-radius:999px;background:#111;color:#fff;pointer-events:none}' +
        '.tsh-up__chip--ship{background:var(--tsh-cart-success,#17853f)}' +
        '.tsh-up__chip--brand{background:rgba(17,17,17,.07);color:#111}' +
        '.tsh-up__price{display:flex;align-items:baseline;flex-wrap:wrap;gap:0 6px}' +
        '.tsh-up__price.has-was [data-upsell-price]{color:var(--tsh-cart-fg,#111)}' +
        '.tsh-up__price s{font-size:11.5px;opacity:.75}' +
        '.tsh-up__price s[hidden]{display:none}' +
        '.tsh-up__select:has(option[value=""]:checked){border-color:rgba(17,17,17,.35)}' +
        '.tsh-up__add.is-choose:disabled{opacity:1;cursor:default;color:var(--tsh-cart-fg,#111);' +
          'background:transparent;box-shadow:inset 0 0 0 1px var(--tsh-cart-line,rgba(17,17,17,.1))}' +
        '@keyframes tshUpIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}' +
        '.tsh-ups__rail .tsh-up[data-ups-cat]{animation:tshUpIn .45s var(--tsh-cart-ease,ease) both}' +
        '.tsh-ups__rail .tsh-up[data-ups-cat]:nth-child(2){animation-delay:.04s}' +
        '.tsh-ups__rail .tsh-up[data-ups-cat]:nth-child(3){animation-delay:.08s}' +
        '.tsh-ups__rail .tsh-up[data-ups-cat]:nth-child(n+4){animation-delay:.12s}' +
        '@media (prefers-reduced-motion:reduce){.tsh-ups__rail .tsh-up[data-ups-cat]{animation:none}}';
      var style = document.createElement('style');
      style.id = 'tsh-ups-css';
      style.textContent = css;
      document.head.appendChild(style);
    }
  })();

  /* ======================================================================
     MEDICIÓN · alimenta el panel "TSH · Impacto de mejoras"
     ----------------------------------------------------------------------
     Deja en el carrito dos atributos ocultos (empiezan por _: no se ven en
     el checkout, pero llegan al pedido y el panel los lee):

       _tsh_wishlist   Cuántos productos del carrito estaban en favoritos.
       _tsh_buscador   "1" si en esta visita se usó el buscador.

     Lo añadido desde el carril de recomendados ya va marcado línea a línea
     con _origen = "Recomendado en carrito" (ver addUpsell).

     Solo llama a /cart/update.js cuando algo cambia. Nunca en bucle.
     Consola:  TshTracking.state()  → qué se mandaría ahora mismo.
     ====================================================================== */
  (function tracking() {
    var WISH_KEY  = 'tsh:wishlist';
    var FLAG_KEY  = 'tsh:buscador';
    var SENT_KEY  = 'tsh:attrs-sent';
    var PIDS_KEY  = 'tsh:cart-pids';
    var TOKEN_KEY = 'tsh:cart-token';

    function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    function wishlist() {
      try {
        var arr = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
        if (!Array.isArray(arr)) return [];
        /* La wishlist guarda objetos { id, title, ... }; las versiones
           antiguas guardaban IDs sueltos. Vale para los dos. */
        return arr.map(function (it) {
          return String(it && typeof it === 'object' ? it.id : it);
        }).filter(function (id) { return id && id !== 'undefined'; });
      } catch (e) { return []; }
    }

    function markSearch() { set(FLAG_KEY, '1'); }

    /* 1 · ¿Ha usado el buscador en esta visita?
       - Página de resultados (/search)
       - Producto abierto desde un resultado (Shopify añade _ss= a la URL)
       - Clic en un resultado del buscador predictivo o envío del formulario */
    if (/\/search(\/|$)/.test(location.pathname) || /[?&]_ss=/.test(location.search)) markSearch();

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      if (a.closest('[data-results], predictive-search, .tsh-sr, [data-row="search"]') ||
          /[?&]_ss=/.test(a.getAttribute('href') || '')) markSearch();
    }, true);

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.tagName === 'FORM' && /\/search/.test(f.getAttribute('action') || '')) markSearch();
    }, true);

    /* 2 · Calcular y mandar los atributos solo si han cambiado */
    function readPids() {
      try {
        var p = JSON.parse(get(PIDS_KEY) || 'null');
        return Array.isArray(p) ? p : null;
      } catch (e) { return null; }
    }

    function compute(pids) {
      var wl = wishlist();
      var n = (pids || []).filter(function (id) { return wl.indexOf(String(id)) > -1; }).length;
      return {
        _tsh_wishlist: n > 0 ? String(n) : '',
        _tsh_buscador: get(FLAG_KEY) === '1' ? '1' : ''
      };
    }

    var timer = null;

    function sync(pids, token) {
      pids  = pids || readPids();
      token = token || get(TOKEN_KEY) || '';
      if (!pids || !pids.length) return; // carrito vacío o desconocido: nada que marcar

      var attrs = compute(pids);
      var sig = token + '|' + attrs._tsh_wishlist + '|' + attrs._tsh_buscador;
      var last = get(SENT_KEY);
      if (last === sig) return;

      // Carrito nuevo sin nada que marcar: no hace falta llamar
      if (!attrs._tsh_wishlist && !attrs._tsh_buscador && (!last || last.split('|')[0] !== token)) {
        set(SENT_KEY, sig);
        return;
      }

      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        })
          .then(function (res) { if (res.ok) set(SENT_KEY, sig); })
          .catch(function (err) { console.warn('[TSH tracking]', err); });
      }, 400);
    }

    // Cada vez que el carrito se repinta (lo emite apply())
    document.addEventListener('cart:update', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart || !Array.isArray(cart.items)) return;
      var pids = cart.items.map(function (i) { return i.product_id; });
      set(PIDS_KEY, JSON.stringify(pids));
      set(TOKEN_KEY, cart.token || '');
      sync(pids, cart.token || '');
    });

    // Si marca o desmarca un favorito con cosas en el carrito
    document.addEventListener('tsh:wishlist:changed', function () {
      setTimeout(function () { sync(); }, 60);
    });

    /* 3 · Eventos de favoritos para el píxel */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-wish-toggle]') : null;
      if (!btn) return;
      var id = btn.dataset.wishId;
      if (!id) return;
      setTimeout(function () {
        var saved = window.TshWishlist && typeof window.TshWishlist.has === 'function'
          ? window.TshWishlist.has(id)
          : btn.classList.contains('is-saved');
        tshPublish(saved ? 'tsh_wishlist_add' : 'tsh_wishlist_remove', {
          productId: String(id),
          title: btn.dataset.wishTitle || '',
          vendor: btn.dataset.wishVendor || '',
          price: btn.dataset.wishPrice || '',
          handle: btn.dataset.wishHandle || ''
        });
      }, 0);
    });

    // El hero usa el evento antiguo
    document.addEventListener('tsh:wishlist:toggle', function (e) {
      var d = e.detail || {};
      if (!d.productId) return;
      tshPublish(d.active ? 'tsh_wishlist_add' : 'tsh_wishlist_remove', {
        productId: String(d.productId), title: d.title || '', vendor: '', price: '', handle: ''
      });
      setTimeout(function () { sync(); }, 60);
    });

    // Al cargar cada página (p. ej. ha buscado después de añadir)
    sync();

    window.TshTracking = {
      state: function () {
        return { attrs: compute(readPids()), pids: readPids(), sent: get(SENT_KEY) };
      }
    };
  })();
})();